export function triggerFileDownload (href: string): void {
  const link: HTMLAnchorElement = document.createElement('a')
  document.body.appendChild(link)
  link.href = href
  link.target = '_blank'
  link.dispatchEvent(new MouseEvent('click'))
  document.body.removeChild(link)
}
